export const N76_02 = {
    "columns": 4,
    "rows": 2,
    "visual": {
      "id": 1,
      "type": "bar2",
      "title": "Top Customers",
      "colorTheme": 'colorTheme2',
      "orientation": "horizontal",
      "xAxis": "Sales",
      "yAxis": "",
      "binding": {
        "data": {
          "series": [
            {
              "name": 'Sales',
              "value": 'ActualSales',
              "type": 'column'
            }
          ],
          "title": "CustomerName",
          "endpoint": "N76.2",
          "parameters": [
            { "key": "FromMonth", "value": "" },
            { "key": "FromYear", "value": "" },
            { "key": "ToMonth", "value": "" },
            { "key": "ToYear", "value": "" },
            { "key": "ConfigTypeCode", "value": "" }
          ]
        },
        "context": {
          "point": {
            "onClick": { }
          }
        }
      }
    }
  }